<template>
    <md-card v-if="!isLoading">
        <md-card-header class="md-card-header-icon md-card-header-warning">
            <div class="card-icon icon-style">
                <md-icon>block</md-icon>
                Blockout days
            </div>
        </md-card-header>
        <md-card-content>
            <template v-if="blockoutDays && blockoutDays.length">
                <div class="blockout-days-container">
                    <div v-for="blockoutDay in blockoutDays" :key="blockoutDay.blockoutDayId">
                        <div class="blockout-day-item">
                            <div class="blockout-day-header">
                                <div class="blockout-day-title">
                                    {{ blockoutDay.serviceAreaName }}
                                </div>
                                <div class="blockout-day-dates">
                                    {{ blockoutDay.blockoutDateRange }}
                                </div>
                            </div>
                            <div class="blockout-day-reason">
                                {{ blockoutDay.blockoutDayName }}
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <span>No blockout days.</span>
            </template>
        </md-card-content>
    </md-card>
</template>

<script>
export default {
    name: 'ServiceAreasDashboardBlockoutDaysComponent',
    props: {
        blockoutDays: {
            type: Array,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>
.icon-style {
    color: white;
}

.blockout-days-container {
    max-height: 300px;
    overflow-y: auto;
    padding-right: 5px;
}

.blockout-day-item {
    padding: 12px;
    margin-bottom: 10px;
    border-radius: 4px;
    background-color: #f9f9f9;
    border-left: 4px solid #ffa726;
}

.blockout-day-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
}

.blockout-day-title {
    font-weight: 600;
    color: #384553;
}

.blockout-day-dates {
    font-weight: 600;
    color: #ef5350;
}

.blockout-day-reason {
    font-size: 13px;
    color: #666;
}
</style>
